// Alpine.js version of supervisor dashboard
export default function supervisorDashboard() {
    return {
        callProgress: [],
        detailedCallProgress: [],
        products: [],
        agentSales: [],
        productId: "0",
        callProgressFilter: {
            productId: "0",
            date: null,
        },
        callProgressDateFilter: null,
        processing: {
            call: false,
            progress: false,
        },

        init() {
            this.loadCallProgress();
            this.loadProducts();
            this.loadMonthlySales();
            this.loadMonthlySalesDetailed();
            this.loadDetailedCallProgress();
        },

        applyCallProgressFilter() {
            this.loadDetailedCallProgress();
        },

        applyCallFilter() {
            this.loadCallProgress();
        },

        async loadCallProgress() {
            this.processing.call = true;

            let url = `/api/supervisor/progress?`;
            if (this.callProgressFilter.date) {
                let [from, to] = this.callProgressFilter.date.split('-');
                from = from.trim();
                to = to.trim();
                url += `from=${from}&to=${to}&`;
            }

            if (this.callProgressFilter.productId != "0") {
                url += `productId=${this.callProgressFilter.productId}`;
            }

            try {
                const response = await fetch(url);
                const data = await response.json();
                this.callProgress = data;
            } catch (error) {
                console.error('Error loading call progress:', error);
            } finally {
                this.processing.call = false;
            }
        },

        async loadDetailedCallProgress() {
            this.processing.progress = true;
            let url = `/api/supervisor/progress/call?`;
            
            if (this.callProgressDateFilter) {
                let [from, to] = this.callProgressDateFilter.split('-');
                from = from.trim();
                to = to.trim();
                url += `from=${from}&to=${to}&`;
            }

            try {
                const response = await fetch(url);
                const data = await response.json();
                this.detailedCallProgress = data;
            } catch (error) {
                console.error('Error loading detailed call progress:', error);
            } finally {
                this.processing.progress = false;
            }
        },

        async loadProducts() {
            try {
                const response = await fetch(`/api/supervisor/products`);
                const data = await response.json();
                this.products = data;
            } catch (error) {
                console.error('Error loading products:', error);
            }
        },

        async loadMonthlySalesDetailed() {
            try {
                const response = await fetch(`/api/supervisor/sales/monthly/detailed`);
                const data = await response.json();
                this.agentSales = data;
            } catch (error) {
                console.error('Error loading monthly sales detailed:', error);
            }
        },

        async loadMonthlySales() {
            try {
                const response = await fetch(`/api/supervisor/sales/monthly`);
                const data = await response.json();
                
                let agents = data;
                let labels = agents.map((agent) => agent.name);
                let chartData = agents.map((agent) => agent.orders_count);
                
                // Initialize Chart.js
                const chartElement = document.getElementById("monthly-sales-chart");
                if (chartElement) {
                    const ctx = chartElement.getContext("2d");
                    new Chart(ctx, {
                        type: "bar",
                        data: {
                            labels: labels,
                            datasets: [
                                {
                                    label: "Sales",
                                    data: chartData,
                                    backgroundColor: "#727cf5",
                                },
                            ],
                        },
                        options: {
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { 
                                    display: false 
                                }
                            },
                            scales: {
                                x: {
                                    display: true,
                                    grid: {
                                        display: false,
                                    },
                                    ticks: {
                                        color: "#8392a5",
                                        font: {
                                            size: 10
                                        }
                                    },
                                },
                                y: {
                                    grid: {
                                        color: "rgba(77, 138, 240, .1)",
                                    },
                                    ticks: {
                                        font: {
                                            size: 10
                                        },
                                        min: 0,
                                    },
                                },
                            },
                        },
                    });
                }
            } catch (error) {
                console.error('Error loading monthly sales:', error);
            }
        }
    }
}